import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import axiosProtected from "../../config/baseWithToken";

export const getInTransitOrders = createAsyncThunk(
  "store/orders/order-tracking",
  async (order, thunkAPI) => {
    try {
      let { data } = await axiosProtected.get(
        `/store/orders/order-trackings?size=${50}&page=${
          order.page || 0
        }&text=${order.text || ""}`
      );
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getAllOrderTrackings = createAsyncThunk(
  "store/orders/order-tracking/all",
  async (order, thunkAPI) => {
    try {
      let { data } = await axiosProtected.get(
        `/store/orders/order-trackings?page=${order?.page}&size=100&text=${
          order?.text || ""
        }&days=${order?.days || ""}&status=${order?.status}&sort=${
          order?.sort
        }&start_date=${order?.start_date || ""}&end_date=${
          order?.end_date || ""
        }&sortBy=${order?.sortBy}`
      );
      // toast.success(data.message)
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
export const getDateFilterTrackingOrders = createAsyncThunk(
  "store/orders/order-tracking/date",
  async (dates, thunkAPI) => {
    try {
      let { data } = await axiosProtected.get(
        `/store/orders/order-tracking/date?start_date=${dates.start_date}&end_date=${dates.end_date}`
      );
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
